import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import GoogleAuth from './GoogleAuth';
import UserRegistrationForm from './UserRegistrationForm';
import { Container, Box, Typography } from '@mui/material';
import { Navigate } from 'react-router-dom';

const LimitedAccessRoute = ({ children }) => {
  const { user, isAuthenticated, isLoading, needsRegistration, login, completeRegistration } = useAuth();

  // 環境変数から許可されたメールアドレスのリストを取得
  const allowedEmails = process.env.REACT_APP_LIMITED_USERS
    ? process.env.REACT_APP_LIMITED_USERS.split(',').map(email => email.trim())
    : [];

  if (isLoading) {
    return (
      <Container maxWidth="sm" sx={{ paddingTop: 4 }}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <Typography>Loading...</Typography>
        </Box>
      </Container>
    );
  }

  if (!isAuthenticated) {
    return (
      <Container maxWidth="sm" sx={{ paddingTop: 4 }}>
        <GoogleAuth 
          onAuthSuccess={login}
          onAuthFailure={(error) => {
            console.error('Authentication failed:', error);
          }}
        />
      </Container>
    );
  }

  if (needsRegistration) {
    return <UserRegistrationForm onComplete={completeRegistration} />;
  }

  // 開発環境ではアクセスを許可
  const isDev = process.env.NODE_ENV === 'development';
  
  // ユーザーが存在し、許可リストに含まれているかチェック
  const isAllowed = user && allowedEmails.includes(user.email);

  if (!isAllowed && !isDev) {
    return (
      <Container maxWidth="md" sx={{ paddingTop: 4 }}>
        <Typography variant="h5" color="error" align="center">
          このページへのアクセス権限がありません
        </Typography>
        <Typography variant="body1" align="center" sx={{ mt: 2 }}>
          ログイン中のアカウント: {user ? user.email : "未ログイン"}
        </Typography>
      </Container>
    );
  }

  return children;
};

export default LimitedAccessRoute;
